import MainNav from './components/nav-bar/MainNav';
import Home from './pages/Home';


function App() {
  
  return (
    <div>
      <MainNav />
      <Home />
    </div>
  );
}

export default App;
